// extracted by mini-css-extract-plugin
export default {"wrapper":"Provider_wrapper__4mZaK"};